// removed by extract-text-webpack-plugin
module.exports = {"iron":"#d3d3d3","lineBreak":"menu_lineBreak_3WGJI","orange":"menu_orange_3Cba5","modal":"menu_modal_37JuK","link":"menu_link_1v5bn","lato-ssubtitle":"menu_lato-ssubtitle_3SNV9 global lato-ssubtitle","lato-subtitle":"menu_lato-subtitle_3MDat global lato-subtitle","menu-mobile":"menu_menu-mobile_RcRoj","submenu-mobile":"menu_submenu-mobile_3YHaP","modal-mobile":"menu_modal-mobile_3TUry"};


//////////////////
// WEBPACK FOOTER
// ./src/component/header/menus/menu.css
// module id = 353
// module chunks = 4